import { FC, useContext, useMemo } from 'react'
import { ThemeContext, ThemeProvider } from 'styled-components'
import { ThemePackage } from '../theme/types'
import { getTheme } from '../theme/utils'

export const useTheme = () => {
    const theme = useContext(ThemeContext)
    if (!theme) throw new Error('`useTheme` called outside of a `ThemeContext` provider')

    return theme
}

export const SpritzThemeProvider: FC = ({ children }) => {
    const contextValue: ThemePackage = useMemo(() => {
        return getTheme()
    }, [])

    return (
        <ThemeProvider theme={contextValue.componentVariables}>
            <>{children}</>
        </ThemeProvider>
    )
}
